export const calculateTotal = ({
  selectedTask = [],
  progressClaims = [],
  progressClaimId = "",
  isRemainingAmountChange = false,
  childTaskMap = {}, // Map of sectionId -> [childTaskIds]
}) => {
  let previous_total_claim_amount = 0;
  let progressClaimTotal = 0;
  let variationsTotal = 0;
  let retentionTotal = 0;
  let claimAmount = 0;
  let currentClaimTotal = 0;

  if (Array.isArray(progressClaims)) {
    progressClaims.forEach((claim) => {
      if (
        claim.u_id !== progressClaimId &&
        Array.isArray(claim.progressClaimTask)
      ) {
        claim.progressClaimTask.forEach((claimTask) => {
          // Support both task and section claims
          let task;
          if (claimTask.stageId && !claimTask.taskId) {
            // Section-level claim - match by stageId
            task = selectedTask.find((t) => t.stageId === claimTask.stageId || t.id === claimTask.stageId);
          } else {
            // Task-level claim - match by taskId
            task = selectedTask.find((t) => t.id === claimTask.taskId);
          }
          if (task) {
            // Use exact saved amount instead of recalculating from percentage
            const claimAmount = parseFloat(claimTask.total || 0);
            previous_total_claim_amount =
              previous_total_claim_amount + claimAmount;
          }
        });
      }
    });
  }

  if (selectedTask && Array.isArray(selectedTask)) {
    selectedTask.forEach((task) => {
      currentClaimTotal = 0; // reset for each task
      // Added SECTION type alongside VARIATION, TASK, SUBTASK
      if (
        task.type === "VARIATION" ||
        task.type === "TASK" ||
        task.type === "SUBTASK" ||
        task.type === "SECTION"
      ) {
        // For SECTION type, totalBefore is already set from aggregated child data
        const taskTotal = task.type === "SECTION"
          ? (parseFloat(task.totalBefore) || parseFloat(task.sub_total) || 0)
          : (parseFloat(task.allocatedMaterialCost) || 0) +
          (parseFloat(task.allocatedLaborCost) || 0) +
          (parseFloat(task.allocatedSubContractorCost) || 0);

        // Pass childTaskIds for section claims if available
        const childTaskIds = task.type === "SECTION" ? (childTaskMap[task.id] || []) : [];

        const claimed = progressClaim({
          task,
          progressClaims,
          progressClaimId,
          childTaskIds,
        });

        // Always use task.remainingAmount as source of truth (user input)
        // Only calculate from percentage if no amount is set AND user hasn't entered anything
        // This prevents overwriting user input with calculated values
        if (
          task.remainingAmount === undefined ||
          task.remainingAmount === null
        ) {
          if (task.remainingPercentage) {
            const remainingDecimal = task.remainingPercentage / 100;
            task.remainingAmount = taskTotal * remainingDecimal;
          } else {
            task.remainingAmount = 0;
          }
        }
        // If task.remainingAmount already has a value (user input), preserve it exactly
        currentClaimTotal = task.remainingAmount || 0;

        // Don't overwrite user's input - let them enter exactly what they want
        // The validation should happen at the UI level, not here
        // if (roundOffValue(claimed + currentClaimTotal) >= roundOffValue(taskTotal)) {
        //     currentClaimTotal = roundOffValue(taskTotal - claimed);
        //     task.remainingAmount = currentClaimTotal;
        // }

        // Handle section name differently
        if (task.type === "SECTION") {
          task.newName = task.name || task.description;
        } else {
          task.newName = task.type === "TASK" ? task.name : task.description;
        }
        if (task.type === "VARIATION") {
          task.newName = `${task.variationNo} ${task.name} ${task.revisionNumber !== 1 ? " - " + task.revisionName : ""
            }`;
        }
      } else if (task.type === "RETENTION") {
        const retentionAmount = parseFloat(task.retentionAmount || 0);
        retentionTotal = retentionTotal + retentionAmount;
        currentClaimTotal = currentClaimTotal + retentionAmount;
      }
      claimAmount += currentClaimTotal;
    });
  }

  progressClaimTotal = previous_total_claim_amount + claimAmount;

  return {
    previous_total_claim_amount,
    selectedTask,
    progressClaimTotal,
    variationsTotal: variationsTotal,
    retentionTotal: retentionTotal,
    claimAmount,
  };
};

// Function to calculate claimedValue for a task
// Also supports SECTION type claims (look up by stageId) and aggregating child tasks
export const progressClaim = ({
  task = {},
  progressClaims = [],
  progressClaimId = "",
  childTaskIds = [],
}) => {
  let claimedValue = 0;

  // Determine if this is a section-level claim
  const isSectionClaim = task.type === 'SECTION';

  // Iterate through all progress claims
  progressClaims.forEach((claim) => {
    if (claim.u_id === progressClaimId) return;
    if (!Array.isArray(claim.progressClaimTask)) return;

    if (isSectionClaim) {
      const sectionStageId = task.stageId || task.id;
      // Get all relevant tasks for this section (either section level or child tasks)
      const matchingTasks = claim.progressClaimTask.filter((claimTask) =>
        claimTask.stageId === sectionStageId ||
        claimTask.stageId === task.id ||
        (childTaskIds && childTaskIds.includes(claimTask.taskId))
      );

      if (matchingTasks.length > 0) {
        // Check if we have a specific section-level claim (taskId is null/undefined)
        const sectionClaims = matchingTasks.filter(t => !t.taskId);

        if (sectionClaims.length > 0) {
          // If we have section-level claims, use those (prevents double counting child tasks)
          sectionClaims.forEach(t => claimedValue += parseFloat(t.total || 0));
        } else {
          // Otherwise sum up the individual child tasks
          matchingTasks.forEach(t => claimedValue += parseFloat(t.total || 0));
        }
      }
    } else {
      // Standard task matching by taskId
      claim.progressClaimTask.forEach((claimTask) => {
        if (claimTask.taskId === task.id) {
          claimedValue += parseFloat(claimTask.total || 0);
        }
      });
    }
  });
  return claimedValue;
};

